const MODULE_NAME = 'fulcrum/containers/Project/GLTCommentSection'

const MOUNT = 'fulcrum/containers/Project/GLTCommentSection/MOUNT'
const UNMOUNT = 'fulcrum/containers/Project/GLTCommentSection/UNMOUNT'

const UPDATE_SELECTED_FASTTRACK_PROJECT = 'fulcrum/containers/Project/GreenlightSection/UPDATE_SELECTED_FASTTRACK_PROJECT'
const POST_FASTTRACK = 'fulcrum/containers/Project/GreenlightSection/POST_FASTTRACK'
const POST_FASTTRACK_START = 'fulcrum/containers/Project/GreenlightSection/POST_FASTTRACK_START'
const POST_FASTTRACK_SUCCESS = 'fulcrum/containers/Project/GreenlightSection/POST_FASTTRACK_SUCCESS'
const POST_FASTTRACK_ERROR = 'fulcrum/containers/Project/GreenlightSection/POST_FASTTRACK_ERROR'

export {
  MODULE_NAME,
  MOUNT,
  UNMOUNT,
  UPDATE_SELECTED_FASTTRACK_PROJECT,
  POST_FASTTRACK,
  POST_FASTTRACK_START,
  POST_FASTTRACK_SUCCESS,
  POST_FASTTRACK_ERROR
}
